window._ = require("lodash");
window.axios = require("axios");
import Loading from "vue-loading-overlay";
if (window.location.hostname == "localhost")
    window.axios.defaults.baseURL = "http://localhost:8000/api";
else if (window.location.hostname == "sdc.asklucknow.in")
    window.axios.defaults.baseURL = "https://sdc.asklucknow.in/api";
else if (window.location.hostname == "pacex.asklucknow.in")
    window.axios.defaults.baseURL = "http://pacex.asklucknow.in/api";
else if (window.location.hostname == "creste.asklucknow.in")
    window.axios.defaults.baseURL = "http://creste.asklucknow.in/api";
else if (window.location.hostname == "crm.chinmaydevelopers.com")
    window.axios.defaults.baseURL = "https://crm.chinmaydevelopers.com/api";
else
    window.axios.defaults.baseURL =
        "https://" + window.location.hostname + "/api";

window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
var loader = null;
window.axios.interceptors.request.use(
    function (config) {
        /*   Pace.start({
        document: false
    }); */
        //NProgress.start();
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

window.axios.interceptors.response.use(
    function (response) {
        // NProgress.done();
        //Pace.stop();
        return response;
    },
    function (error) {
        // NProgress.done();
        //console.log("error"+error.response.status );
        /*if(error.response.status === 403||error.response.status === 401||error.response.status === 500||error.response.status === 404) {
        // redirect to login page
        window.location.href = "404";
    }*/
        return Promise.reject(error);
    }
);
